<template>
    <div class="form-body">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group" v-if="lovTypes">
                    <label for="type"><span class="required">*</span>{{ $t("labels.type") }}</label>
                    <select class="form-control" @change="$emit('typechanged')" v-model="lov.type">
                        <option v-for="lovType in lovTypes" :value="lovType" :key="lovType">{{ translatedLovType(lovType) }}</option>                        
                    </select>
                </div>

                <div class="form-group">
                    <label for="name_en"><span class="required">*</span>{{ $t("labels.name_en") }}</label>
                    <input type="text" id="name_en" class="form-control" v-model="lov.name.en">
                </div>
                <template v-for="(locale, index) in availableLocales">
                  <div class="form-group" :key="index">
                    <label :for="'name_' + locale">{{ $t("labels.name_" + locale) }}</label>
                    <input type="text" :id="'name_' + locale" class="form-control" v-model="lov.name[locale]">
                  </div>
                </template>

            </div>
            <div class="col-md-6">
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ["lov","lovTypes"],
  methods: {
    translatedLovType: function(lovType){      
      return this.$t(`lovTypes.${lovType}`)
    }
  },
  data() {
    return {
      availableLocales: ['de','es','fr','cr','it','nl']
    }
  },
   
}
</script>
